import type { SVGProps } from 'react';
import { memo } from 'react';

import { SVG_STOROKE_SIZE } from '@/data/shared/constant';

import { IconSizeType } from '@/types/icon';

interface SvgIconProps extends SVGProps<SVGSVGElement> {
  size: IconSizeType;
}
const SvgIconPauseRound = ({ size = 24, ...props }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 24 24"
    className="svgr-icon-component"
    strokeWidth={SVG_STOROKE_SIZE[size]}
    {...props}
  >
    <g clipPath="url(#icon-pause-round__a)">
      <path
        stroke="currentColor"
        strokeLinecap="round"
        d="M8 4v16m8-16v16"
        vectorEffect="non-scaling-stroke"
      />
    </g>
    <defs>
      <clipPath id="icon-pause-round__a">
        <path fill="currentColor" d="M7 3h10v18H7z" />
      </clipPath>
    </defs>
  </svg>
);
const Memo = memo(SvgIconPauseRound);
export default Memo;
